import classes from "./SmallBlogsCard.module.scss";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { ClockCircleOutlined } from "@ant-design/icons";
import ClampText from "../TextTruncate/TextTruncate";

const SmallBlogCard = ({ blogData }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/blogs/" + blogData._id);
  };
  const day = blogData?.publishDate?.slice(0, 10);

  return (
    <div onClick={handleClick} className={classes.card}>
      <div className={classes.cardImage}>
        <img
          src={blogData?.image || blogData?.coverImage || ""}
          alt={blogData?.title}
        />
      </div>
      <div className={classes.cardContent}>
        <h2 className={classes.cardTitle}>{blogData?.title}</h2>
        <div className={classes.cardContent__body}>
          <div className={classes.card__author}>
            <div className={classes.card__author__image}>
              <img src={blogData?.user.image} />
            </div>
            <div className={classes.card__author__name}>
              <span>By </span>
              {blogData?.user.fullName}
            </div>
            <div className={classes.card__author__date}>
              <ClockCircleOutlined />
              {day}
            </div>
          </div>

          <div className={classes.card__text}>
            <ClampText text={blogData?.content} lines={7} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallBlogCard;
